import React from 'react';
import { Megaphone, ArrowRight, Check, Bell } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useAuth } from '../../context/AuthContext';

const NewProductLaunchesPage = () => {
  const { login } = useAuth();

  const features = [
    'Anúncios de lançamento',
    'Lista de espera automática',
    'Notificações segmentadas',
    'Pré-vendas',
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-purple-100 text-purple-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <Megaphone className="h-4 w-4" />
                Lançamentos
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                <span className="text-purple-600">Lançamentos</span> de produtos
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Anuncie novos produtos e crie listas de espera automaticamente pelo chatbot.
              </p>
              <Button onClick={login} size="lg" className="bg-[#3b82f6] hover:bg-[#2563eb]">
                Começar gratuitamente
              </Button>
            </div>
            <div className="bg-gradient-to-br from-purple-600 to-pink-600 rounded-3xl p-8 text-white">
              <div className="flex items-center gap-3 mb-4">
                <Bell className="h-6 w-6" />
                <span className="font-semibold">Novo lançamento!</span>
              </div>
              <div className="bg-white/20 backdrop-blur rounded-xl p-4 mb-4">
                <p className="font-bold mb-1">🚀 Produto X - Chegou!</p>
                <p className="text-sm opacity-80">Seja o primeiro a comprar</p>
              </div>
              <Button className="w-full bg-white text-purple-600 hover:bg-gray-100">
                Quero ser avisado
              </Button>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Recursos</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((feature) => (
                <div key={feature} className="bg-white rounded-xl p-6 shadow-sm">
                  <Check className="h-6 w-6 text-green-500 mb-3" />
                  <p className="font-medium text-gray-900">{feature}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <Card className="bg-gradient-to-br from-[#3b82f6] to-[#1d4ed8] text-white">
              <CardContent className="py-12 text-center">
                <h2 className="text-2xl font-bold mb-4">Lance produtos com sucesso</h2>
                <Button onClick={login} variant="secondary" size="lg" className="bg-white text-[#3b82f6] hover:bg-gray-100">
                  Começar agora <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NewProductLaunchesPage;
